export default [

    {
        id: 5,
        type: 'document',
        icon: '',
        name: 'Empathy Sketch',
        group: 'Build Empathy',
        description: 'Engage students in an activity that requires them to note observations and think deeply about the way an issue might impact themselves and others. ',
        instructions: 'Instruct students to complete the Empathy Sketch by considering what community members shared in the podcast. Reflect on the importance of starting with community members\' experiences.',
        file: {
            url: 'https://drive.google.com/file/d/1RLB6czY4HxGyTQpshwJSmno67NFFiiXp/view?usp=sharing'
        },
        options: {
            width: 1
        }
    },

    {
        id: 6,
        type: 'document',
        icon: '',
        name: 'Root Cause Tree',
        group: 'Analyze the Issue',
        description: 'Engage students in a Root Cause Analysis to further investigate and analyze an issue for its underlying factors. ',
        instructions: '"Introduce the Root Cause Analysis Tree and write the issue (in the trunk). \n' +
            'Engage students in sharing points from their Empathy Sketch. \n' +
            'Instruct students to write points shared in the “Symptoms” section. \n' +
            'Select (and/or add) appropriate questions from the “Symptoms” section and instruct students to answer those selected questions in the “Symptoms” section. \n' +
            'Refer back to the “Facts” section and ask students to add new facts they learned from the podcast. \n' +
            'Select (and/or add) appropriate questions from the “Root Cause” section and instruct students to answer those selected questions in the “Root Cause” section. \n' +
            'Reflect on the process. \n' +
            'Select a root cause."',
        file: {
            url: 'https://drive.google.com/file/d/1R-w8emH3NVAQFTi9QIuZA6GyVbtifCWh/view?usp=sharing'
        },
        options: {
            width: 1
        }
    },

    {
        id: 7,
        type: 'document',
        icon: '',
        name: 'Framing Up',
        group: 'Frame the Question',
        description: 'Engage students in framing their design question.',
        instructions: 'Introduce and show the framing question: How might we address ____________________ in a world where ___________________?\n' +
            'Instruct students to fill in the framing question by adding the selected root cause in the first space. \n' +
            'Instruct students to complete the framing question by adding selected symptoms in the second space.',
        file: {
            url: 'https://drive.google.com/file/d/1-q8IoC11Fo8g31NB2w8SIciSyyCS6b8O/view?usp=sharing'
        },
        options: {
            width: 1
        }
    },

    {
        id: 8,
        type: 'document',
        icon: '',
        name: 'Rapid Brainstorming',
        group: 'Brainstorm Ideas',
        description: 'Facilitate rounds of brainstorming that engage students in creative thinking and encourage them to consider a variety of perspectives. ',
        instructions: 'Refer to and discuss framing question from the Feel stage. \n' +
            'Engage students in a written brainstorm, answering the framing question, “How might we…?” Encourage students to write as many ideas as they can. \n' +
            'Engage students in additional brainstorms around the framing question, adding one or more of the following (or any other) lenses: \n' +
            'How might we… if we had unlimited money?\n' +
            'How might Harry Potter…? How might [character from relevant text]...? \n' +
            'How might we… in space? How might we… in a relevant location? \n' +
            'Engage students in a constraint brainstorm around the framing question based. Below are examples: \n' +
            'How might we… with no technology? \n' +
            'How might we… with no money? \n' +
            'How might we… with limited time? \n' +
            'Categorize the ideas based on similarity of concept (and feasibility). Clarify, define or replace categories as necessary for student understanding. Below are example categories: \n' +
            'Advocacy or Support\n' +
            'Awareness\n' +
            'Education\n' +
            'Access to Resources\n' +
            '“Blue Sky” (i.e. ideas that are not currently feasible)\n' +
            '“Bandaids” (i.e. ideas that do not connect to the root cause)',
        file: {
            url: 'https://docs.google.com/document/d/1ieRWMrD2MM-Lel2vy6SBCQM3c3lrVsFwFstU-l0aMAk'
        },
        options: {
            width: 1
        }
    },

    {
        id: 9,
        type: 'document',
        icon: '',
        name: 'Idea Selecting',
        group: 'Select an Idea',
        description: 'Engage students in selecting an idea.',
        instructions: 'Select an idea or set of ideas to pursue by engaging students in one or more of the following: self-selecting into small groups, voting on one to pursue as a class, discussing to reach consensus, or debating to decide on one idea or set of ideas. Instruct students to engage in written reflection about their idea or idea set in one or more of the following ways: Pretend to describe the idea to a younger sibling or younger peer. Pretend to describe the idea to a relevant character in a text. Pretend to describe the idea to a specific community member. Pretend to describe the idea to a school leader or community leader.',
        file: {
            url: 'https://docs.google.com/document/d/1ieRWMrD2MM-Lel2vy6SBCQM3c3lrVsFwFstU-l0aMAk'
        },
        options: {
            width: 1
        }
    },

    {
        id: 10,
        type: 'document',
        icon: '',
        name: 'If-Then',
        group: 'Select an Idea',
        description: 'Facilitate reflection in which students consider what might be true if they implement their idea.',
        instructions: 'Instruct students to visualize the idea or idea set considering the question, “What might be true after we implement our idea?” \n' +
            'Instruct students to write or draw their visualization. \n' +
            'Instruct students to write their idea or idea set in the “Idea” section of their If-Then map. \n' +
            'Instruct students to consider potential results or impact of their idea and write them in the spaces stemming from the “Idea” section of their If-Then map.',
        file: {
            url: 'https://drive.google.com/file/d/1q3bciDQjOWzhE1rnobopCVLneursuBgH/view?usp=sharing'
        },
        options: {
            width: 1
        }
    },

    {
        id: 11,
        type: 'document',
        icon: '',
        name: 'Storyboard Prototype',
        group: 'Develop a Plan',
        description: 'Engage students in a process of outlining action steps and creating an initial plan for their idea.',
        instructions: 'Instruct students to consider the idea they selected and list out all of the action steps that might be required. Engage students in the activity “Oh, Tell Me More” by selecting one student to share one action step listed. Then state, “oh, tell me more” and another student adds detail to the action step shared. Repeat this process a few times. Group similar action items and prioritize the most important steps. Instruct students to create a storyboard that outlines the most important steps.',
        file: {
            url: 'https://drive.google.com/file/d/1pBlpY0CVUwARirjBBNCWnc8RDM8m8BGT/view?usp=sharing'
        },
        options: {
            width: 1
        }
    },


    {
        id: 12,
        type: 'document',
        icon: '',
        name: 'Storyboard Feedback',
        group: 'Get Feedback and Reflect',
        description: 'Engage students in collectively providing feedback on their plan for changemaking. ',
        instructions: 'Annotate the storyboard using one or more (or any other) of the following annotations: \n' +
            '?: Add a question mark (and the question) next to any point that is still unclear. \n' +
            '+: Add a plus sign next to any point that needs additional information. \n' +
            '☆: Add a star sign next to any point that indicates a strength or an asset in the community. \n' +
            '▵: Add a triangle next to any point that may require modification. \n' +
            'Discuss the annotations.',
        file: {
            url: 'https://drive.google.com/file/d/1m51fYQF4lycA9dwtVxnKcZ8BSPMHktAp/view?usp=sharing'
        },
        options: {
            width: 1
        }
    },


    {
        id: 13,
        type: 'document',
        icon: '',
        name: 'Action Plan',
        group: 'Develop a Plan',
        description: 'Engage students in the process of action planning.',
        instructions: 'Engage students in further developing their Action Plan by selecting the first action step and defining on more of the following:  \n' +
            'What to Do: Write a simple statement of the action step. \n' +
            'By Whom: Delegate the action step (or parts of the action step). \n' +
            'Alongside Whom: Name additional individuals that will be involved in the action step (i.e. community members). \n' +
            'By When: Set a date to complete the Action Plan. \n' +
            'With What: Name the resources that will be necessary to complete the Action Plan. \n' +
            'Repeat with selected action steps (or all action steps).',
        file: {
            url: 'https://docs.google.com/document/d/1XvQwVx8bDIeGFai3vvt76ErIvH89jPbKDINXdofug3I/edit'
        },
        options: {
            width: 1
        }
    },

    {
        id: 14,
        type: 'document',
        icon: '',
        name: 'I Wish, I Like, I Wonder',
        group: 'Get Feedback and Reflect',
        description: 'Support students to further reflect on their changemaking. ',
        instructions: 'Instruct students to reflect on their Action Plan.\n' +
            'Instruct students to consider parts of their Action Plan they prefer or like and indicate them in the “I Like” section.\n' +
            'Instruct students to consider changes or modifications they would like to make to their Action Plan or the circumstances or context around their Action Plan and indicate them in the “I Wish” section.\n' +
            'Instruct students to consider parts of their Action Plan about which they are still curious and indicate them in the “I Wonder” section.\n' +
            '5. Discuss each of the sections: I Like, I Wish, and I Wonder.',
        file: {
            url: 'https://drive.google.com/file/d/1i0ybhjRVtt_98q29Z0TjLHu1fY01rTlI/view?usp=sharing'
        },
        options: {
            width: 1
        }
    },

    {
        id: 15,
        type: 'document',
        icon: '',
        name: 'Limitless Lessons',
        group: 'Make Meaning',
        description: 'Engage students in a series of reflections to identify and solidify their lessons learned.',
        instructions: 'Revisit one or more of the artifacts from the previous stages. Below are examples: \n' +
            'Root Cause Analysis from the Feel stage\n' +
            'If-Then map from the Imagine stage \n' +
            'I Wish, I Like, I Wonder from the Do stage\n' +
            'Consider one or more of the following questions with regards to the artifacts and engage students in written reflection or verbal discussion: \n' +
            'What more do we know? What have we learned? What might we add to this artifact? \n' +
            'What changes have we observed? What changes might we make to this artifact?  What do these changes make us think?\n' +
            'Rewrite the framing question from the Imagine stage (i.e. “How might we…?) into a statement, using the sentence started, “We planned to….” in the “Plan” section. \n' +
            'Instruct students to engage in written reflection about their plan in one or more of the following ways and record their reflection in the “Plan” section: \n' +
            'Pretend to describe the plan to a younger sibling or younger peer.\n' +
            'Pretend to describe the plan to a relevant character in a text. \n' +
            'Pretend to describe the plan to a specific community member. \n' +
            'Pretend to describe the plan to a school leader or community leader.\n' +
            'Engage students in written reflection (and a discussion) around the following: \n' +
            'One or more lessons learned about yourself in the “Self-Reflection” section\n' +
            'One or more lessons learned about the issue in the “Issue Reflection” section\n' +
            'One or more lessons learned about your community (and, especially, the assets or strengths of the community) in the “Community Reflection” section\n' +
            'One or more lessons learned about the process of making change in the “Changemaking Reflection” section\n' +
            'Instruct students to prepare to share one lesson learned through a written reflection, class or partner or group discussion, poster or an in-class presentation.',
        file: {
            url: 'https://docs.google.com/document/d/1h9Giv9BI3gSB3op0szbKx3m8FfWTsqU2rP23Y8gFGME/edit'
        },
        options: {
            width: 1
        }
    },


];
